import SupportBanner from "~/components/analytics/suite/Setup/SupportBanner";

type Props = {
  suiteSlug: string;
  suiteOidcPolicyUrl: string;
};

const ContentTestsPlugin = ({ suiteSlug, suiteOidcPolicyUrl }: Props) => (
  <>
    <p>
      The{" "}
      <a className="purple" href="https://github.com/buildkite-plugins/tests-buildkite-plugin">
        Tests plugin
      </a>{" "}
      sets up your pipeline to run tests with Buildkite Test Engine. It automatically downloads the{" "}
      <a className="purple" href="https://buildkite.com/docs/test-engine/test-engine-client">
        Test Engine Client
      </a>
      , handles OIDC authentication, and configures the required environment variables.
    </p>

    <p>Add the plugin to your pipeline step and set your test runner:</p>

    <pre className="code">
      {[
        "steps:",
        '  - label: "Test"',
        "    command: bktec run",
        "    plugins:",
        "      - tests#v1.0.0:",
        "          test-runner: rspec",
        "          result-path: tmp/rspec-result.json",
        `          suite-slug: ${suiteSlug}`,
        "    parallelism: 2",
      ].join("\n")}
    </pre>

    <p>
      The <code className="inline-block">test-runner</code> option specifies which framework to use.
      Supported values include <code className="inline-block">rspec</code>,{" "}
      <code className="inline-block">jest</code>, <code className="inline-block">pytest</code>,{" "}
      <code className="inline-block">gotest</code>, and{" "}
      <code className="inline-block">cypress</code>.
    </p>

    <p>
      Then set an{" "}
      <a className="purple" href={suiteOidcPolicyUrl}>
        OIDC policy
      </a>{" "}
      on this suite to allow your pipeline to authenticate. For example:
    </p>

    <pre className="code">
      {[
        "- iss: https://agent.buildkite.com",
        "  claims:",
        "    organization_slug: your-org",
        "    pipeline_slug: your-pipeline",
        "  scopes:",
        "    - read_suites",
        "    - read_test_plan",
        "    - write_test_plan",
        "    - write_uploads",
      ].join("\n")}
    </pre>

    <p>
      See the{" "}
      <a className="purple" href="https://github.com/buildkite-plugins/tests-buildkite-plugin">
        Tests plugin README
      </a>{" "}
      for the full list of options including test splitting, Docker support, and dynamic
      parallelism.
    </p>

    <SupportBanner />
  </>
);

export default ContentTestsPlugin;
